import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { ButtonWithGAClickButton, ModalHeader, Typography } from 'common/components';
import { ENTRANCE_DOORS_ELEMENT_BLOCK } from '../../../../entrance-doors-constants';

type DurableSteelProps = {
  onConsultationSignupBtnClick: () => void;
};

export const DurableSteel = ({ onConsultationSignupBtnClick }: DurableSteelProps) => (
  <>
    <ModalHeader title="Прочная сталь" />
    <ModalContent>
      <Typography variant="m" size="body_long">
        Чем лист стали толще, тем долговечнее и&nbsp;тяжелее входная дверь. Толщина нашей стали&nbsp;&mdash;
        от&nbsp;1,5&nbsp;мм. Мы&nbsp;подберём для вас сбалансированную толщину. Так дверь будет
        не&nbsp;слишком тяжелой, чтобы ею&nbsp;было удобно пользоваться людям любого возраста,
        не&nbsp;подвергнется провисанию, а&nbsp;её&nbsp;прочности хватит на&nbsp;десятки лет.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={ENTRANCE_DOORS_ELEMENT_BLOCK}
        elementText="Оставить заявку"
        elementName="Прочная сталь"
        onClick={onConsultationSignupBtnClick}
        wide>
        Оставить заявку
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
